import { Controller } from "@hotwired/stimulus"

// Disables submit after first submit (e.g. full-page POST with turbo: false) to avoid double taps.
export default class extends Controller {
  lock() {
    const button = this.element.querySelector('button[type="submit"]')
    if (!button || button.disabled) return

    button.disabled = true
    button.classList.add("is-loading")
  }
}
